class StickyCartBar extends HTMLElement {
  connectedCallback() {
    this.mainButton = document.getElementById(this.dataset.watchId);

    if (this.mainButton && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        if (entry) this.toggle(entry.isIntersecting);
      }, { threshold: 0 });
      this.observer.observe(this.mainButton);
      this.toggle(this.isButtonInView());
      return;
    }

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.onScrollHandler();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
    document.documentElement.classList.remove('sticky-cart-visible');
  }

  isButtonInView() {
    if (!this.mainButton) return false;
    const rect = this.mainButton.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  onScroll() {
    if (this.mainButton) {
      this.toggle(this.isButtonInView());
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.toggle(scrollTop <= this.getOffsetTop(this));
  }

  toggle(mainButtonVisible) {
    if (mainButtonVisible) {
      this.removeAttribute('animate');
      document.documentElement.classList.remove('sticky-cart-visible');
    } else {
      this.setAttribute('animate', '');
      document.documentElement.classList.add('sticky-cart-visible');
    }
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}

if (!customElements.get('sticky-cart-bar')) {
  customElements.define('sticky-cart-bar', StickyCartBar);
}
